import { Error, Loading } from '@organisms/Feedbacks';
import styled from 'styled-components';
import { dateFormat, postCodeFormat } from '../Utils';

type Props = {
    listData: any;
};

const createMoushikomiJoukyouList = (idoMoshikomiUketsukes: any) => {
    const length = idoMoshikomiUketsukes.idoMoshikomiUketsuke?.length || 0;
    if (length === 0) {
        return (
            <tbody>
                <tr>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                </tr>
            </tbody>
        );
    } else {
        return (
            <tbody>
                {idoMoshikomiUketsukes.idoMoshikomiUketsuke.map((params:any)=> {
                    return (
                        <tr key={`${params.idoMoshikomiUketsukeMoshikomiShubetsu}${params.idoMoshikomiUketsukeYmd}`}>
                            <td>{dateFormat(params.idoMoshikomiUketsukeYmd)}</td>
                            <td>{params.idoMoshikomiUketsukeMoshikomiShubetsuMeisho}</td>
                            <td>{params.idoMoshikomiUketsukeKoteiMeisho}</td>
                        </tr>
                    );
                })}
            </tbody>
        );
    }
}

const DetailFacilityInfo = (props:Props) => {
    const { listData } = props;
    const { data, error, loading } = listData;

    return (
        <WrapperWithStyled className='detailTableWrapper'>
            {loading && <Loading />}
            {error && <Error />}
            {data &&
                <div>
                    <table className='table table-bordered table-success'>
                        <tbody>
                            <tr>
                                <th className='cell-20per'>供給地点住所</th>
                                <td colSpan={3} className='cell-80per'>
                                    {postCodeFormat(data.yubinNo)}　{data.jusho} {data.tatemono}
                                </td>
                            </tr>
                            <tr>
                                <th className='cell-20per'>廃止措置方法</th>
                                <td className='cell-30per'>
                                    {data.haishiSochiHohoMeisho || ""}
                                </td>
                                <th className='cell-20per'>契約者名</th>
                                <td className='cell-30per'>
                                    {data.juyoshaShimeiKanji || ""}
                                </td>
                            </tr>
                            <tr>
                                <th className='cell-20per'>契約形態</th>
                                <td className='cell-30per'>{data.keiyakuKeitaiTaKeiyakuKeitaiMeisho}</td>
                                <th className='cell-20per'>契約電流</th>
                                <td className='cell-30per'>{data.keiyakuDenryuKbnMeisho}</td>
                            </tr>
                            <tr>
                                <th>契約電力</th>
                                <td>{data.keiyakuDenryoku} {data.keiyakuDenryokuTaniMeisho}</td>
                                <th>契約容量</th>
                                <td>{data.keiyakuYoryo} {data.keiyakuYoryoTaniMeisho}</td>
                            </tr>
                            <tr>
                                <th>契約決定方法</th>
                                <td>{data.keiyakuKetteiHohoMeisho}</td>
                                <th>供給方式</th>
                                <td>{data.kyokyuHoshikiMeisho}</td>
                            </tr>
                            <tr>
                                <th>他契約形態１</th>
                                <td>{data.takeiyakukeitai1Meisho}</td>
                                <th>他契約形態２</th>
                                <td>{data.takeiyakukeitai2Meisho}</td>
                            </tr>
                            <tr>
                                <th>太陽光、自家発などの系統連系設備</th>
                                <td colSpan={3}>{data.taiyokoJikahatsuKeitoRenkeiSetsubiMeisho}</td>
                            </tr>
                            <tr>
                                <th>基本検針日</th>
                                <td colSpan={3}>{data.kihonKenshinDay} {data.kihonKenshinDay ? '日' : ''}</td>
                            </tr>
                            <tr>
                                <th>前回検針日</th>
                                <td>{dateFormat(data.zenkaiKenshinYmd)}</td>
                                <th>次回検針日</th>
                                <td>{dateFormat(data.jikaiKenshinYmd)}</td>
                            </tr>
                        </tbody>
                    </table>
                    <SubTitileWithStyled>申請状況</SubTitileWithStyled>
                    <table className='table table-bordered table-success'>
                        <thead>
                            <tr>
                                <th className='cell-20per'>申込受付年月日</th>
                                <th className='cell-40per'>申込種別</th>
                                <th className='cell-40per'>受付工程</th>
                            </tr>
                        </thead>
                        {data.idoMoshikomiUketsukes ? createMoushikomiJoukyouList(data.idoMoshikomiUketsukes) : ''}
                    </table>
                    <SubTitileWithStyled>計器情報</SubTitileWithStyled>
                    <table className='table table-bordered table-success'>
                        <thead>
                            <tr>
                                <th className='cell-20per'>計器番号</th>
                                <th className='cell-20per'>計器番号容量</th>
                                <th className='cell-40per'>30分値収集可否・自動検針可否</th>
                                <th className='cell-20per'>Ｂルート通信方式</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{data.keikiNo1}</td>
                                <td>{data.keikiNo1Yoryo}</td>
                                <td>{data.keikiNo130minJidoKenshinKahiMeisho}</td>
                                <td>{data.keikiNo1B_rootTsushinHoshikiMeisho}</td>
                            </tr>
                            <tr>
                                <td>{data.keikiNo2}</td>
                                <td>{data.keikiNo2Yoryo}</td>
                                <td>{data.keikiNo230minJidoKenshinKahiMeisho}</td>
                                <td>{data.keikiNo2B_rootTsushinHoshikiMeisho}</td>
                            </tr>
                            <tr>
                                <td>{data.keikiNo3}</td>
                                <td>{data.keikiNo3Yoryo}</td>
                                <td>{data.keikiNo330minJidoKenshinKahiMeisho}</td>
                                <td>{data.keikiNo3B_rootTsushinHoshikiMeisho}</td>
                            </tr>
                            <tr>
                                <td>{data.keikiNo4}</td>
                                <td>{data.keikiNo4Yoryo}</td>
                                <td>{data.keikiNo430minJidoKenshinKahiMeisho}</td>
                                <td>{data.keikiNo4B_rootTsushinHoshikiMeisho}</td>
                            </tr>
                            <tr>
                                <td>{data.keikiNo5}</td>
                                <td>{data.keikiNo5Yoryo}</td>
                                <td>{data.keikiNo530minJidoKenshinKahiMeisho}</td>
                                <td>{data.keikiNo5B_rootTsushinHoshikiMeisho}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            }
        </WrapperWithStyled>
    );
};

const WrapperWithStyled = styled.div`
    margin: 0 0 10px;
    & td {
        background-color: white;
    }
`
const SubTitileWithStyled = styled.h3`
    margin: 20px 0 5px 5px;
    font-size: 16px;
    font-weight: bold;
`

export default DetailFacilityInfo;